// Lista ricambi auto comuni ordinati per frequenza di sostituzione
export const autoPartsDescriptions = [
  // Manutenzione ordinaria - molto comuni
  "Olio motore",
  "Filtro olio",
  "Filtro aria",
  "Filtro abitacolo",
  "Filtro carburante",
  "Candele accensione",
  "Bobine accensione",
  "Cinghia distribuzione",
  "Kit distribuzione completo",
  "Kit distribuzione + pompa acqua",
  "Cinghia servizi",
  "Cinghia alternatore",
  "Tendicinghia",
  
  // Freni - molto comuni
  "Pastiglie freno anteriori",
  "Pastiglie freno posteriori",
  "Kit pastiglie freno anteriori + posteriori",
  "Dischi freno anteriori",
  "Dischi freno posteriori",
  "Kit dischi + pastiglie anteriori",
  "Kit dischi + pastiglie posteriori",
  "Kit freni completo ant + post",
  "Pinza freno anteriore dx",
  "Pinza freno anteriore sx",
  "Pinza freno posteriore dx",
  "Pinza freno posteriore sx",
  "Tamburo freno",
  "Ganasce freno",
  "Liquido freni DOT 4",
  "Tubo freno flessibile",
  "Pompa freno",
  "Servofreno",
  
  // Sospensioni - comuni
  "Ammortizzatore anteriore dx",
  "Ammortizzatore anteriore sx",
  "Ammortizzatore posteriore dx",
  "Ammortizzatore posteriore sx",
  "Kit ammortizzatori anteriori",
  "Kit ammortizzatori posteriori",
  "Kit ammortizzatori completo",
  "Molla ammortizzatore anteriore",
  "Molla ammortizzatore posteriore",
  "Kit molle ammortizzatori",
  "Supporto ammortizzatore",
  "Braccio oscillante anteriore dx",
  "Braccio oscillante anteriore sx",
  "Kit bracci oscillanti",
  "Bielletta barra stabilizzatrice",
  "Barra stabilizzatrice anteriore",
  "Barra stabilizzatrice posteriore",
  "Testina sterzo dx",
  "Testina sterzo sx",
  "Tirante sterzo",
  "Scatola sterzo",
  "Pompa servosterzo",
  "Cuscinetto ruota anteriore dx",
  "Cuscinetto ruota anteriore sx",
  "Cuscinetto ruota posteriore dx",
  "Cuscinetto ruota posteriore sx",
  "Mozzo ruota",
  "Silent block",
  "Gommino sospensione",
  
  // Motore - comuni
  "Pompa acqua",
  "Termostato",
  "Radiatore",
  "Ventola radiatore",
  "Elettroventola",
  "Manicotto radiatore superiore",
  "Manicotto radiatore inferiore",
  "Vaschetta espansione",
  "Tappo radiatore",
  "Liquido raffreddamento",
  "Sensore temperatura",
  "Guarnizione testata",
  "Kit guarnizioni motore",
  "Guarnizione coppa olio",
  "Paraolio albero motore",
  "Paraolio albero a camme",
  "Catena distribuzione",
  "Kit catena distribuzione",
  "Tendicatena",
  "Coperchio punterie",
  "Guarnizione coperchio punterie",
  "Valvola EGR",
  "Collettore aspirazione",
  "Collettore scarico",
  "Turbocompressore",
  "Intercooler",
  "Debimetro",
  "Sensore albero motore",
  "Sensore albero a camme",
  "Sensore pressione olio",
  "Pompa olio",
  "Supporto motore dx",
  "Supporto motore sx",
  "Supporto cambio",
  
  // Alimentazione
  "Pompa carburante",
  "Filtro carburante diesel",
  "Iniettore benzina",
  "Iniettore diesel",
  "Kit iniettori",
  "Rail iniettori",
  "Pompa alta pressione",
  "Regolatore pressione carburante",
  "Corpo farfallato",
  "Sensore pedale acceleratore",
  "Tubo carburante",
  
  // Scarico
  "Marmitta anteriore",
  "Marmitta centrale",
  "Marmitta posteriore",
  "Catalizzatore",
  "FAP/DPF filtro antiparticolato",
  "Sonda lambda",
  "Collettore di scarico",
  "Guarnizione scarico",
  "Fascetta scarico",
  "Silenziatore",
  
  // Impianto elettrico
  "Batteria",
  "Alternatore",
  "Motorino avviamento",
  "Centralina motore",
  "Centralina iniezione",
  "Sensore ABS anteriore dx",
  "Sensore ABS anteriore sx",
  "Sensore ABS posteriore dx",
  "Sensore ABS posteriore sx",
  "Centralina ABS",
  "Pompa ABS",
  "Sensore parcheggio",
  "Telecamera retromarcia",
  "Faro anteriore dx",
  "Faro anteriore sx",
  "Fanale posteriore dx",
  "Fanale posteriore sx",
  "Lampada H7",
  "Lampada H4",
  "Lampada H1",
  "Kit lampade LED",
  "Lampada xenon D1S",
  "Lampada xenon D2S",
  "Ballast xenon",
  "Motorino tergicristallo",
  "Spazzole tergicristallo",
  "Kit spazzole tergicristallo",
  "Pompa lavavetri",
  "Motorino alzavetro dx",
  "Motorino alzavetro sx",
  "Pulsantiera alzavetro",
  "Specchietto retrovisore dx",
  "Specchietto retrovisore sx",
  "Vetro specchietto dx",
  "Vetro specchietto sx",
  "Clacson",
  "Relè",
  "Fusibile",
  
  // Climatizzazione
  "Compressore aria condizionata",
  "Condensatore A/C",
  "Evaporatore A/C",
  "Filtro essiccatore A/C",
  "Valvola espansione A/C",
  "Tubo A/C",
  "Ricarica gas R134a",
  "Ricarica gas R1234yf",
  "Ventilatore abitacolo",
  "Resistenza ventilatore",
  "Radiatore riscaldamento",
  "Valvola riscaldamento",
  
  // Trasmissione
  "Frizione",
  "Kit frizione completo",
  "Kit frizione + volano",
  "Disco frizione",
  "Spingidisco",
  "Cuscinetto reggispinta",
  "Volano bimassa",
  "Volano monomassa",
  "Cilindro frizione",
  "Pompa frizione",
  "Cavo frizione",
  "Semiasse dx",
  "Semiasse sx",
  "Giunto omocinetico",
  "Cuffia semiasse",
  "Kit cuffie semiasse",
  "Cambio automatico",
  "Cambio manuale",
  "Olio cambio",
  "Olio cambio automatico ATF",
  "Cuscinetto cambio",
  "Sincronizzatore",
  "Selettore cambio",
  "Leveraggio cambio",
  "Differenziale",
  "Olio differenziale",
  
  // Carrozzeria
  "Paraurti anteriore",
  "Paraurti posteriore",
  "Cofano",
  "Parafango anteriore dx",
  "Parafango anteriore sx",
  "Parafango posteriore dx",
  "Parafango posteriore sx",
  "Porta anteriore dx",
  "Porta anteriore sx",
  "Porta posteriore dx",
  "Porta posteriore sx",
  "Portellone",
  "Baule",
  "Tetto",
  "Pannello porta",
  "Maniglia porta esterna",
  "Maniglia porta interna",
  "Serratura porta",
  "Parabrezza",
  "Lunotto",
  "Vetro laterale dx",
  "Vetro laterale sx",
  "Modanatura porta",
  "Passaruota",
  "Sottoporta",
  "Traversa anteriore",
  "Traversa posteriore",
  
  // Kit completi
  "Kit tagliando completo",
  "Kit tagliando + distribuzione",
  "Kit revisione freni",
  "Kit revisione sospensioni",
  "Kit cinghie completo",
  "Kit guarnizioni testata",
  "Kit paraolio motore",
  "Kit silent block sospensioni",
  "Kit braccetti sterzo",
  "Kit gommini sospensione",
  
  // Altro
  "Manuale uso e manutenzione",
  "Chiave telecomando",
  "Telecomando chiusura centralizzata",
  "Serratura accensione",
  "Pedale acceleratore",
  "Pedale freno",
  "Pedale frizione",
  "Leva cambio",
  "Pomello cambio",
  "Cuffia leva cambio",
  "Volante",
  "Airbag guidatore",
  "Airbag passeggero",
  "Airbag laterale",
  "Cintura sicurezza",
  "Pretensionatore cintura",
  "Sedile anteriore",
  "Sedile posteriore",
  "Poggiatesta",
  "Tappetini",
  "Copertura bagagliaio"
];

export default autoPartsDescriptions;
